module.exports = __webpack_public_path__ + "static/img/2023_9_8_15.3b36d50f.3b36d50.png";


//////////////////
// WEBPACK FOOTER
// ./assets/img/2023_9_8_15.3b36d50f.png
// module id = gMER
// module chunks = 0